import { render, staticRenderFns } from "./PagosDetalle.vue?vue&type=template&id=4fa40d04&scoped=true"
import script from "./PagosDetalle.vue?vue&type=script&lang=js"
export * from "./PagosDetalle.vue?vue&type=script&lang=js"
import style0 from "./PagosDetalle.vue?vue&type=style&index=0&id=4fa40d04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa40d04",
  null
  
)

export default component.exports